<template>
  <div class="layout-section layout-section--images-summary">
    <h3>Images In Your Account: {{ numTotal }}</h3>

    <div class="image-type-button-panel">
      <router-link to="/images-list-pending">
        <div @click="rerenderView" class="stat-button stat-button--orange">
          <div class="stat-button__qty">
            <i class="fas fa-cloud-upload-alt"></i>
            <span class="badge badge-light stat-button__badge">{{
              numPending
            }}</span>
          </div>
          <p class="stat-button__type-label">Uploads</p>
          <p class="stat-button__cmd-label">
            <i class="fas fa-list"></i>
          </p>
        </div>
      </router-link>

      <router-link to="/images-list-selected">
        <div @click="rerenderView" class="stat-button stat-button--blue">
          <div class="stat-button__qty">
            <i class="fas fa-check-square"></i>
            <span class="badge badge-light stat-button__badge">{{
              numSelected
            }}</span>
          </div>
          <p class="stat-button__type-label">Selected</p>
          <p class="stat-button__cmd-label">
            <i class="fas fa-list"></i>
          </p>
        </div>
      </router-link>

      <router-link to="/images-list-published">
        <div @click="rerenderView" class="stat-button stat-button--green">
          <div class="stat-button__qty">
            <i class="fas fa-book-open"></i>
            <span class="badge badge-light stat-button__badge">{{
              numPublished
            }}</span>
          </div>
          <p class="stat-button__type-label">Published</p>
          <p class="stat-button__cmd-label">
            <i class="fas fa-list"></i>
          </p>
        </div>
      </router-link>

      <router-link to="/images-list-unusable">
        <div @click="rerenderView" class="stat-button stat-button--red">
          <div class="stat-button__qty">
            <i class="fas fa-minus"></i>
            <span class="badge badge-light stat-button__badge">{{
              numRejected
            }}</span>
          </div>
          <p class="stat-button__type-label">Unusable</p>
          <p class="stat-button__cmd-label">
            <i class="fas fa-list"></i>
          </p>
        </div>
      </router-link>
    </div>
    <!-- end image-type-button-panel -->

    <div
      class="layout-section layout-section--images-summary layout-section--uploads-remaining"
    >
      <p>
        <!-- <span># Uploads: {{ numPending }} / {{ maxNumUploads }}</span> -->
        <span>Max Upload Slots: {{ maxNumUploads }}</span>
        <!-- <span>Total Images: {{ numTotal }}</span> -->
      </p>
    </div>

    <div class="layout-section layout-section--image-action">
      <!-- <p v-if="numPending === 0">
        You have {{ maxNumUploads }} upload slots available.
      </p>
      <p v-if="numPending > 0 && maxNumUploads - numPending > 1">
        You have {{ maxNumUploads - numPending }} upload slots available.
      </p>
      <p v-if="numPending > 0 && maxNumUploads - numPending == 1">
        You have one (1) upload slot available.
      </p>
      <div v-if="showNoSlotsAvailableText">
        <p>You have no upload slots available.</p>
        <p>Delete an upload or wait until we select one for publishing.</p>
      </div> -->

      <div v-if="uploadSlotsAvailable">
        <p>Upload slots available: {{ maxNumUploads - numPending }}</p>
      </div>
      <div v-else class="layout-section__content layout-section__content--300w">
        <p>Upload slots available: 0</p>
        <p>
          A slot becomes available when you delete an upload or we select one
          for publishing.
        </p>
      </div>

      <router-link to="/upload-image" class="nodec"
        ><button
          v-if="showUploadImageBtn"
          class="layout-section__btn layout-section__btn--action-orange layout-section__btn--block-centered"
          @click="rerenderView"
        >
          <i class="fas fa-cloud-upload-alt"></i> Upload Image
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('uploadTracker', ['imageCounts']),
    // ...mapGetters('auth', ['authUser']),
    ...mapGetters(['uploadCompleted']),

    onUploadPage: function () {
      return this.$route.name === 'Upload' ? true : false;
    },
    // Check if there are any upload slots available; if yes, return true, else return false
    uploadSlotsAvailable: function () {
      if (this.numPending < this.maxNumUploads) {
        return true;
      }
      return false;
    },

    // showNoSlotsAvailableText: function () {
    //   if (this.numPending > 0 && this.maxNumUploads - this.numPending <= 0) {
    //     return true;
    //   }
    //   return false;
    // },
    showUploadImageBtn: function () {
      if (this.uploadSlotsAvailable) {
        // If on upload page, hide the button initially. But, since we stay on the upload page at end of upload process
        // (showing the upload result (success or error)), show the button so user can click and upload another.
        if (this.onUploadPage) {
          return this.uploadCompleted ? true : false;
        }
        return true;
      }
      return false;
      // if (this.$route.name === 'Upload') {
      //   return false;
      // }
      // return !this.showNoSlotsAvailableText;
      // return this.uploadSlotsAvailable;
    },
    maxNumUploads: function () {
      return this.imageCounts.maxNumPending || 0;
    },
    numUploadsRemaining: function () {
      return this.maxNumUploads - this.numPending;
    },
    numPending: function () {
      return this.imageCounts.numSubmitted + this.imageCounts.numPending || 0;
    },
    numSelected: function () {
      return this.imageCounts.numSelected || 0;
    },
    numPublished: function () {
      return this.imageCounts.numPublished || 0;
    },
    numRejected: function () {
      return this.imageCounts.numRejected || 0;
    },
    numTotal: function () {
      return (
        this.numPending +
        this.numSelected +
        this.numPublished +
        this.numRejected
      );
    },
  },

  methods: {
    rerenderView: function () {
      this.$parent.rerenderView();
    },
    uploadImage: function () {
      this.$router.push('/upload-image');
    },
  },
  created: async function () {
    console.log('********CAME FROM:', document.referrer);
  },
};
</script>

<style>
</style>